module.exports = __webpack_public_path__ + "img/slide5.63c00e56.png";